import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface SortGroupsCommand {
  dragIndex: number;
  hoverIndex: number;
}

export const sortGroups: GraphCommandFactory<SortGroupsCommand> =
  (cmdContext) => (command) => {
    cmdContext.updateState((draft) => {
      const { presetDraft } = draft.layoutSettings;
      // Fixed noUncheckedIndexedAccess NIM-19408
      const draggedGroup = presetDraft.edges[command.dragIndex]!;
      presetDraft.edges.splice(command.dragIndex, 1);
      presetDraft.edges.splice(command.hoverIndex, 0, draggedGroup);
    });
  };
